import { render, staticRenderFns } from "./ItineraryStaffPickEvents.vue?vue&type=template&id=84dd6798&scoped=true&"
import script from "./ItineraryStaffPickEvents.vue?vue&type=script&lang=js&"
export * from "./ItineraryStaffPickEvents.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryStaffPickEvents.vue?vue&type=style&index=0&id=84dd6798&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dd6798",
  null
  
)

export default component.exports